import "./index.scss";

function NotaryToolbarDivider() {
  return <div data-automation-id="notary-toolbar-divider" className="NotaryToolbarDivider" />;
}

export default NotaryToolbarDivider;
